export enum ImportFileTypes {
    PDF = 'application/pdf',
    DWG = '.dwg',
}
